export default __webpack_public_path__ + "static/media/undraw_online_video_ivvq.2f2403f1.png";